import { Button, Form, Input, Modal } from 'antd';
import React from 'react';
import { PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE } from '../../utils/validationConstants';

const UpdatePasswordModal = ({
  onClickUpdatePassword,
  setVisible,
  visible,
  resetPasswordLoading,
}) => (
    <Modal
      maskClosable={false}
      destroyOnClose
      title="Update Password"
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={onClickUpdatePassword}
        name="updatePasswordForm"
      >
        <Form.Item
          label="Old Password"
          name="old_password"
          rules={[
            {
              required: true,
              message: 'This field is required',
            },
            {
              pattern: PASSWORD_REGEX,
              message: PASSWORD_VALIDATION_MESSAGE,
            },
          ]}
        >
          <Input.Password placeholder="E.g. ABCD1234" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          rules={[
            {
              required: true,
              message: 'This field is required',
            },
            {
              pattern: PASSWORD_REGEX,
              message: PASSWORD_VALIDATION_MESSAGE,
            },
          ]}
        >
          <Input.Password placeholder="E.g. DCBA4312" />
        </Form.Item>
        <div style={{ textAlign: 'right' }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={resetPasswordLoading}
          >
            Update Password
          </Button>
        </div>
      </Form>
    </Modal>
  );

export default UpdatePasswordModal;
